var map = {
	"./accept_fio.svg": 83205,
	"./accept_fio_hover.svg": 86262,
	"./arrow_back.svg": 7181,
	"./arrow_back__active.svg": 8565,
	"./cancel_fio.svg": 58843,
	"./cancel_fio_hover.svg": 94988,
	"./change_pasword.svg": 75463,
	"./change_pasword_black.svg": 56523,
	"./copy.svg": 72689,
	"./copy_active.svg": 70466,
	"./crown_blue.svg": 94646,
	"./crown_white.svg": 261,
	"./delete_photo.svg": 12166,
	"./delete_photo_red.svg": 40642,
	"./exit.svg": 41762,
	"./pencil.svg": 33849,
	"./restore.svg": 59148,
	"./restore_active.svg": 97833,
	"./unblock.svg": 96774,
	"./unblock_active.svg": 39499,
	"./update_photo.svg": 23852,
	"./update_photo_black.svg": 91128,
	"./user_email.svg": 97458,
	"./user_full_name.svg": 66109,
	"./user_name.svg": 46379
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33478;